import React from 'react'

export const FileDnDContext = React.createContext({
    isDragging: false,
    dataTransfer: null,
    currentHoveredDropzoneId: null,
    setCurrentHoveredDropzoneId: Function.prototype
})
